import './jquery-global';
/* global jQuery */
import Rails from '@rails/ujs';

// https://github.com/hopsoft/debounced
import debounced from 'debounced';
import preserveSidebarScroll from '../preserve_sidebar_scroll';
import rememberExploreTab from '../explore_tab_memory';
import TurboFrameErrorRenderer from '../turbo_frame_error_renderer';
import '@hotwired/turbo-rails';
// Telemetry for `turbo:frame-missing` events ("Content missing" UI) and
// `turbo:fetch-request-error`. Reports to /turbo_diagnostics.
import '../turbo_diagnostics';
import '../sidebar_slider';
import '../stimulus_setup';
import '../stream_actions';

if (!window._rails_loaded) {
  Rails.start();
}

if (window.RAILS_ENV === 'development' || window.RAILS_ENV === 'test') {
  // provide feedback to devs when turbo-frame load fails
  TurboFrameErrorRenderer.start();
}

// Preserve sidebar scroll
preserveSidebarScroll();
rememberExploreTab();

// TODO: remove this once ajax calls are migrated to fetch
window.ajax = jQuery.ajax;

// Sync date input value attribute on change so the CSS [value]:not([value=""])
// selector reflects the current value immediately after the user picks a date.
document.addEventListener('change', (event) => {
  if (event.target.type === 'date') {
    event.target.setAttribute('value', event.target.value);
  }
});

// Config for debounced library. Specify which stimulus actions are eligible for
// debouncing, and how long the debounce is. Syntax is e.g.:
//
// <input data-action="debounced:input->form#submit"
//
debounced.initialize({
  input: { wait: 300 },
});

jQuery.ajaxPrefilter((options, _originalOptions, _jqXHR) => {
  const { beforeSend: beforeSendOption } = options;

  options.beforeSend = function beforeSend(xhr) {
    const token = jQuery('meta[name="csrf-token"]').attr('content');
    if (token) { xhr.setRequestHeader('X-CSRF-Token', token); }

    if (beforeSendOption) { return beforeSendOption.apply(this, arguments); }
    return null;
  };
});
